module.exports = __webpack_public_path__ + "img/645b7ef.png";